export default {
    props: ['edit'],
    data() {
        return {
            form: {},
            page:{},
            danger: null,
            success: null,
            isNew: false
        }
    },
    watch: {
        edit() {
            this.getForm()
        }
    },
    mounted() {
        this.getForm()
    },
    methods: {
        getForm() {

            if (this.edit && !this.isNew) {

                this.axios.get(this.action + '/' + this.edit)
                    .then(({data}) => {
                        if(data.hasOwnProperty('current_page')){
                            this.page = data;
                        }else{
                            this.form = data.data;
                        }
                    })
                    .catch((error) => {
                        this.danger = 'خطایی رخ داده است';
                    });
                this.danger = null;
                this.success = null;
            } else {

                this.isNew = false;
            }

        },
        submitForm: function (e) {
            if (this.edit) {

                // Update
                this.$validator.validateAll().then((result) => {
                    if (result) {

                        this.success = this.danger = null;


                        this.axios.put(this.action + '/' + this.edit, this.form)
                            .then(({data}) => {
                                this.success = 'با موفقیت انجام شد';
                                this.$emit('updated', data.data.id);

                            })
                            .catch((error) => {
                                this.danger = 'خطایی رخ داده است';
                            });

                    }
                });
            } else {
                // Insert

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.isNew = true;
                        this.success = this.danger = null;
                        this.axios.post(this.action, this.form)
                            .then(({data}) => {
                                this.success = 'با موفقیت انجام شد';
                                this.$emit('created', data.data.id);
                            })
                            .catch(({response}) => {
                                this.danger = Object.values(response.data).join(' ');
                            });
                    }
                });
            }


        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/mixinForm.js